import { loadDemoDb } from "./demoDb";
import {
  expandDemoKindergartenMenu,
  fetchDemoKindergartensList,
  injectDemoKindergartenAboutMenuItems,
  isKindergartenParentModule,
} from "./expandDemoKindergartenMenu";

function getKindergartenIdFromSection(section) {
  for (const c of section?.children || []) {
    const key = typeof c?.key === "string" ? c.key.replace(/^\//, "") : "";
    const m = key.match(/^kindergarten\/(\d+)\//);
    if (m) return m[1];
  }
  return null;
}

function applySectionNames(accessGroup, kindergartens, savedMap) {
  const nameById = new Map(
    (kindergartens || []).map((k) => [String(k.id), k.name]),
  );
  let fallbackIndex = 0;

  return (accessGroup || []).map((m) => {
    // Demo-only rename: keep prod data untouched.
    if (m?.module_name === "Відділ освіти") {
      return { ...m, module_name: "Управління освіти" };
    }

    const moduleId = String(m?.module_id ?? "");
    const overrideName = savedMap[moduleId];
    if (overrideName) return { ...m, module_name: overrideName };

    if (isKindergartenParentModule(m)) {
      const kgId = getKindergartenIdFromSection(m);
      const fromApi = kgId ? nameById.get(kgId) : null;
      if (fromApi) return { ...m, module_name: fromApi };
      fallbackIndex += 1;
      return { ...m, module_name: `Тестовий садочок ${fallbackIndex}` };
    }
    return m;
  });
}

/**
 * Повне демо-меню: розширити садочками з API + назви + «Про нас».
 * Лише для демо-користувача; prod не викликає.
 */
export async function buildDemoUserMenu(userInfo) {
  if (!userInfo || !Array.isArray(userInfo.access_group)) return userInfo;

  const kindergartens = await fetchDemoKindergartensList();
  let access_group = expandDemoKindergartenMenu(userInfo.access_group, kindergartens);

  const db = loadDemoDb();
  const savedMap = db?.menuOverrides?.moduleNameById || {};
  access_group = applySectionNames(access_group, kindergartens, savedMap);
  access_group = access_group.map(injectDemoKindergartenAboutMenuItems);

  return { ...userInfo, access_group };
}
